import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map ,switchMap } from 'rxjs/operators';
import { AccountService } from '../../shared/account.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private headerOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  private webMasterId: string | null = null;

  constructor( private http: HttpClient ,private accountservice: AccountService) {
    this.webMasterId = localStorage.getItem('webMasterId');
   }


  getVariants(): Observable<any> {
    return this.accountservice.get().pipe(
      switchMap((user) => {
       
        if (this.webMasterId) {
          const apiUrl = `api/filterorder/getWebMasterSkus?webMaster=${encodeURIComponent(this.webMasterId)}`;
          return this.http.get(apiUrl);
        } else {
          return this.http.get('api/product/getVariants');
        }
      })
    );
  }
  
  

  getVariantByCompanies(companyIds: number[]) {
    let url = 'api/product/getVariantByCompanies';
    if (companyIds !== null) {
      url += `?companyIds=${companyIds.join(',')}`;
    } else {
      url += `?companyIds=`;
    }
    return this.http.get(url).pipe(map((res: Response) => res));
  }

  getVariantByWebMasters(webMaster: string[]) {
    let url = 'api/product/getVariantByWebMasters';
    if (webMaster && webMaster.length > 0) {
      url += `?webMaster=${webMaster.join(',')}`;
    } else {
      url += `?webMaster=`;
    }
    return this.http.get(url).pipe(map((res: Response) => res));
}



  checkVariantExist(sku: string) {
    let params: HttpParams = new HttpParams()
      .set('sku', sku);
    this.headerOptions["search"] = params;
    return this.http.get('/api/product/checkVariantExist', { params }/*this.headerOptions*/).pipe(map((res: Response) => res))
  }
  getVariantBySku(sku: string){
    let params: HttpParams = new HttpParams()
    .set('sku', sku);
  this.headerOptions["search"] = params;
  return this.http.get('/api/product/getVariantBySku', { params }/*this.headerOptions*/).pipe(map((res: Response) => res))
  }
  getVariantsByCompany(){
    return this.http.get('api/product/getallVariantsByCompany');
  }
  getVariantss(term: string = null): Observable<string[]> {
    return new Observable((observer) => {
      let getSkuName: Promise<any>;

      getSkuName = new Promise((resolve) => {
        this.http.get<string[]>('api/product/getVariants').subscribe((data: any) => {
          resolve(data.states);
        });
      });

      getSkuName.then((data) => {
        if (term) {
          data = data.filter(x => x.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1);
        }
        observer.next(data);
      });
    });
  }

  updateOrderDimensions(data: any) {
    return this.http.post('api/orders/orderPackage/updateOrderDimensions', data);
  }
}
